import { User } from "@/assets/icons";
import { SmartLink } from "@/components/ui";

export function LogIn() {
    return (
        <div className="flex items-center justify-center gap-3">
            <div className="hidden sm:flex">
                <SmartLink type="external" route="login">
                    <p>Log In</p>
                </SmartLink>
            </div>
            <div className="bg-ochre_accent shadow-xs rounded-full p-1.5">
                <SmartLink type="external" route="login">
                    <User className="size-6" />
                </SmartLink>
            </div>
        </div>
    )
}